import React from 'react';
import styles from 'styles/driver-compensations-data.module.scss';
import markIcon from 'images/markIcon.svg'
import circleIcon from 'images/circleIcon.svg'

const columns = (value: string) => [
  {
    age: '① 記名被保険者本人',
    under20: ['D', 'H', 'L'].includes(value) ? (
      <img className={styles.image} src={circleIcon} alt="マル" />
    ) : (
      <img className={styles.image} src={markIcon} alt="バツ" />
    ),
    under25: ['C', 'D', 'G', 'H', 'K', 'L'].includes(value) ? (
      <img className={styles.image} src={circleIcon} alt="マル" />
    ) : (
      <img className={styles.image} src={markIcon} alt="バツ" />
    ),
    under34: ['B', 'C', 'D', 'F', 'G', 'H', 'J', 'K', 'L'].includes(value) ? (
      <img className={styles.image} src={circleIcon} alt="マル" />
    ) : (
      <img className={styles.image} src={markIcon} alt="バツ" />
    ),
    over35: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L'].includes(value) ? (
      <img className={styles.image} src={circleIcon} alt="マル" />
    ) : (
      <img className={styles.image} src={markIcon} alt="バツ" />
    )
  },
  {
    age: '② ①の配偶者',
    under20: ['H', 'L'].includes(value) ? (
      <img className={styles.image} src={circleIcon} alt="マル" />
    ) : (
      <img className={styles.image} src={markIcon} alt="バツ" />
    ),
    under25: ['G', 'H', 'K', 'L'].includes(value) ? (
      <img className={styles.image} src={circleIcon} alt="マル" />
    ) : (
      <img className={styles.image} src={markIcon} alt="バツ" />
    ),
    under34: ['F', 'G', 'H', 'J', 'K', 'L'].includes(value) ? (
      <img className={styles.image} src={circleIcon} alt="マル" />
    ) : (
      <img className={styles.image} src={markIcon} alt="バツ" />
    ),
    over35: ['E', 'F', 'G', 'H', 'I', 'J', 'K', 'L'].includes(value) ? (
      <img className={styles.image} src={circleIcon} alt="マル" />
    ) : (
      <img className={styles.image} src={markIcon} alt="バツ" />
    )
    },
  {
    age: '③ ①または②の同居の親族',
    under20: ['L'].includes(value) ? (
      <img className={styles.image} src={circleIcon} alt="マル" />
    ) : (
      <img className={styles.image} src={markIcon} alt="バツ" />
    ),
    under25: ['K', 'L'].includes(value) ? (
      <img className={styles.image} src={circleIcon} alt="マル" />
    ) : (
      <img className={styles.image} src={markIcon} alt="バツ" />
    ),
    under34: ['J', 'K', 'L'].includes(value) ? (
      <img className={styles.image} src={circleIcon} alt="マル" />
    ) : (
      <img className={styles.image} src={markIcon} alt="バツ" />
    ),
    over35: ['I', 'J', 'K', 'L'].includes(value) ? (
      <img className={styles.image} src={circleIcon} alt="マル" />
    ) : (
      <img className={styles.image} src={markIcon} alt="バツ" />
    )
  },
  {
    age: '④ ①または②の別居の未婚の子',
    under20: ['I', 'J', 'K', 'L'].includes(value) ? (
      <img className={styles.image} src={circleIcon} alt="マル" />
    ) : (
      <img className={styles.image} src={markIcon} alt="バツ" />
    ),
    under25: ['I', 'J', 'K', 'L'].includes(value) ? (
      <img className={styles.image} src={circleIcon} alt="マル" />
    ) : (
      <img className={styles.image} src={markIcon} alt="バツ" />
    ),
    under34: ['I', 'J', 'K', 'L'].includes(value) ? (
      <img className={styles.image} src={circleIcon} alt="マル" />
    ) : (
      <img className={styles.image} src={markIcon} alt="バツ" />
    ),
    over35: ['I', 'J', 'K', 'L'].includes(value) ? (
      <img className={styles.image} src={circleIcon} alt="マル" />
    ) : (
      <img className={styles.image} src={markIcon} alt="バツ" />
    )
  },
  {
    age: '⑤ 上記以外（友人・知人など）',
    under20: ['I', 'J', 'K', 'L'].includes(value) ? (
      <img className={styles.image} src={circleIcon} alt="マル" />
    ) : (
      <img className={styles.image} src={markIcon} alt="バツ" />
    ),
    under25: ['I', 'J', 'K', 'L'].includes(value) ? (
      <img className={styles.image} src={circleIcon} alt="マル" />
    ) : (
      <img className={styles.image} src={markIcon} alt="バツ" />
    ),
    under34: ['I', 'J', 'K', 'L'].includes(value) ? (
      <img className={styles.image} src={circleIcon} alt="マル" />
    ) : (
      <img className={styles.image} src={markIcon} alt="バツ" />
    ),
    over35: ['I', 'J', 'K', 'L'].includes(value) ? (
      <img className={styles.image} src={circleIcon} alt="マル" />
    ) : (
      <img className={styles.image} src={markIcon} alt="バツ" />
    )
  }
]

export default columns